import { Injectable } from "@angular/core";
import { ICreatedUserOutput, IRegisterDetails } from "@gloria-public/register/domain/interfaces/registration.interface";
import { ApiService } from "@shared/services/api.service";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class RegistrationService {
  constructor(private api: ApiService) {}

  /**
   * Creates a new user account
   * @param user information about the user to register
   * @return user output
   */
  public createUser(user: IRegisterDetails): Observable<ICreatedUserOutput> {
    return this.api.post("clients", user, this.api.appendGuestHeader()) as Observable<ICreatedUserOutput>;
  }
}
